
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.695 5.927a6.257 6.257 0 016.346-1.54.95.95 0 10.578-1.81A8.17 8.17 0 003.555 13.426a.188.188 0 01-.071.228l-1.064.7a.76.76 0 00.264 1.381l3.35.69a.76.76 0 00.896-.592l.694-3.349a.76.76 0 00-1.162-.788l-1.018.67a.19.19 0 01-.285-.101 6.284 6.284 0 011.536-6.337zm13.456-.255a.76.76 0 00-.58-.613l-3.335-.76a.76.76 0 00-.912.572l-.76 3.334a.76.76 0 001.146.812l1.096-.688a.188.188 0 01.282.1 6.27 6.27 0 01-7.816 7.922.95.95 0 10-.56 1.815A8.17 8.17 0 0018.709 7.32a.188.188 0 01.076-.228l1.023-.643a.76.76 0 00.343-.777z","fill":"#FFF"}})])
          )
        }
      }
    